import { PTC_FARE_CATEGORY, type PtcFareTypeCode } from '@/constants/components/fareType'
import { FareType } from '@/types/srp'
import { getFaresInfo } from '@/utils/srp/helper'
import { ProcessedData } from '@/utils/srp/types'

type useFilteredCardsProps = {
    sortedFilteredCards:any
    fares: any,
    subTravelOptions: any
    isRT: any
    processedData: ProcessedData
    isSrpRevamp?: boolean
}

export type PtcAvailability = Record<PtcFareTypeCode, boolean>

const EMPTY_PTC_AVAILABILITY: PtcAvailability = {
    student: false,
    senior_citizen: false,
    army: false,
}

const useSpecialFareCards = ({
    sortedFilteredCards, fares, subTravelOptions, processedData, isSrpRevamp = false
}: useFilteredCardsProps) => {
    let ptcFareCards: any[] = [[],[]]
    const sortedFilteredCardsNoPTC: any[] = [[], []]
    let isPtc = false
    const ptcFareTypes = Object.values(PTC_FARE_CATEGORY)
    let cheapestRegularFare = [1000000000, 1000000000]
    const { isIntl } = processedData
    const keepCombinedPtcList = isIntl || isSrpRevamp
    let isOnwardPtcFareAvailable = false
    let isReturnPtcFareAvailable = false
    const ptcAvailability: PtcAvailability = { ...EMPTY_PTC_AVAILABILITY }

    const markPtcAvailability = (fareCard: any) => {
        ;(Object.keys(PTC_FARE_CATEGORY) as PtcFareTypeCode[]).forEach(ptcType => {
            if (ptcAvailability[ptcType]) return
            const faresObjectList: FareType[] =
                getFaresInfo(fareCard, subTravelOptions, fares, false, false, ptcType) || []
            if (faresObjectList.some(fare => fare?.fareCategory === PTC_FARE_CATEGORY[ptcType])) {
                ptcAvailability[ptcType] = true
            }
        })
    }

    
    const filterPTCFromSortedCards = () => {
        sortedFilteredCards?.[0]?.forEach((fareCard:any) => {
            const subTravelOption = subTravelOptions?.[fareCard?.subTravelOptionIds?.[0]]
            const faresObjectList: FareType[] = getFaresInfo(fareCard, subTravelOptions, fares, false, false, 'student') || []
            const cheapestFareId = subTravelOption?.cheapestFareId || ''
            const fare = fares[cheapestFareId]
            const isPtcFare = ptcFareTypes.includes(fare?.fareCategory)
            const isPtcFareAvailable = faresObjectList?.some((fare: any) => {
                return ptcFareTypes.includes(fare?.fareCategory)
            })
            markPtcAvailability(fareCard)
            if (!isOnwardPtcFareAvailable && (isPtcFareAvailable || fare?.fareCategory === 'RETAIL_STUDENT')) {
                isOnwardPtcFareAvailable = true
            }
            if (!keepCombinedPtcList && isPtcFare) {
                ptcFareCards[0].push(fareCard)
                isPtc = true
            }
            else {
                if (fare?.pricing?.perAdultPricing?.totalPrice < cheapestRegularFare[0]) {
                    cheapestRegularFare[0] = fare?.pricing?.perAdultPricing?.totalPrice
                }
                sortedFilteredCardsNoPTC[0].push(fareCard)
            }
            
        })
        sortedFilteredCards?.[1]?.forEach((fareCard:any) => {
            const subTravelOption = subTravelOptions?.[fareCard?.subTravelOptionIds?.[0]]
            const faresObjectList: FareType[] = getFaresInfo(fareCard, subTravelOptions, fares, false, false, 'student') || []
            const cheapestFareId = subTravelOption?.cheapestFareId || ''
            const fare = fares[cheapestFareId]
            const isPtcFare = ptcFareTypes.includes(fare?.fareCategory)
            const isPtcFareAvailable = faresObjectList?.some((fare: any) => {
                return ptcFareTypes.includes(fare?.fareCategory)
            })
            markPtcAvailability(fareCard)
            if (!isReturnPtcFareAvailable && (isPtcFareAvailable || fare?.fareCategory === 'RETAIL_STUDENT')) {
                isReturnPtcFareAvailable = true
            }
            if (!keepCombinedPtcList && isPtcFare) {
                ptcFareCards[1].push(fareCard)
                isPtc = true
            }
            else {
                if (fare?.pricing?.perAdultPricing?.totalPrice < cheapestRegularFare[1]) {
                    cheapestRegularFare[1] = fare?.pricing?.perAdultPricing?.totalPrice
                }
                sortedFilteredCardsNoPTC[1].push(fareCard)
            }
        })
        if (cheapestRegularFare[0] === 1000000000 || cheapestRegularFare[1] === 1000000000) { 
            cheapestRegularFare = [0,0]
        }
    }
    filterPTCFromSortedCards()
    return {
        ptcFareCards,
        sortedFilteredCardsNoPTC,
        isPtc,
        cheapestRegularFare,
        isOnwardPtcFareAvailable,
        isReturnPtcFareAvailable,
        ptcAvailability,
    }
}

export default useSpecialFareCards
